import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error-warning-fill",
  "use": "icon-error-warning-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-error-warning-fill\">\n    <g>\n        <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n        <path d=\"M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm0-8v6h2V7h-2z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol